import { render } from "./HomeClasicos.vue?vue&type=template&id=52be3ece&scoped=true"
import script from "./HomeClasicos.vue?vue&type=script&lang=js"
export * from "./HomeClasicos.vue?vue&type=script&lang=js"

import "./HomeClasicos.vue?vue&type=style&index=0&id=52be3ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52be3ece"]])

export default __exports__